import { DodajUzytkownikaModel } from "./dodajUzytkownikaModel";

export class EdytujUzytkownikaModel extends DodajUzytkownikaModel {
    id: string;
}